import { TierType } from 'pages/Shifts/ShiftDetail/types'

export const shiftKey = ['shift']

export const shiftDetailKey = (shiftId: number) => [...shiftKey, shiftId]

export const shiftAnalysisKeyWithParams = (shiftId: number) => [
  ...shiftDetailKey(shiftId),
  'analysis',
]

export const shiftSummaryKeyWithParams = (shiftId: number) => [
  ...shiftDetailKey(shiftId),
  'summary',
]

export const tierEligibilitiesByShiftIdKey = (shiftId: number) => [
  ...shiftDetailKey(shiftId),
  'tier-eligibilities',
]

export const shiftRosterByShiftIdKey = (shiftId: number) => [
  ...shiftDetailKey(shiftId),
  'roster',
]

export const shiftWorkBreaksKey = (shiftId: number, workId: number) => [
  ...shiftDetailKey(shiftId),
  'work',
  workId,
  'breaks',
]

export const customShiftNotificationsKey = (shiftId?: number) =>
  [...shiftKey, shiftId, 'custom-notifications'] as const

export const tierStatsByShiftIdKey = (shiftId: number, tier: TierType) => [
  ...tierEligibilitiesByShiftIdKey(shiftId),
  tier,
]

export const shiftsKey = ['shifts']
export const shiftsKeyWithParams = (
  params: (string | number | boolean | (string | number)[])[]
) => [...shiftsKey, ...params]

export const listShiftsKey = (params: {
  type?: string
  startDate?: string
  endDate?: string
  companyIds?: number[]
  shiftId?: number | string
  market?: string
  isUnfilled?: boolean
}) => [
  ...shiftsKey,
  params.type,
  params.startDate,
  params.endDate,
  params.companyIds,
  params.shiftId,
  params.market,
  params.isUnfilled,
]
